import React from 'react';
import { AdminRouteName } from '../../../CONSTANTS';

import TransactionTableRecords from '../TransactionTableRecord';

const AllTransaction = () => (
  <div className="transaction-root-cover">
    <TransactionTableRecords hasNameAndImage recordPermission="can-view-all-transaction-tab" defaultUrl={AdminRouteName.transactionRoute} toggleStorageId="all-transaction-table-col" />
  </div>
);
export default AllTransaction;
